export const footerList = [
  { 
    title: 'Photo AI',
    children: [
      {
        title: 'BGRmover',
        href: '/ai/image/background-remover/'
      },
      {
        title: 'ImageColorizer',
        href: '/image-colorizer/'
      },
      {
        title: 'ColorEnhancer',
        href: '/image-enhancer/'
      },
      {
        title: 'ClearityEnhancer',
        href: '/image-enhancer/'
      },
      {
        title: 'ResolutionEnhancer',
        href: '/image-enhancer/'
      },
    ]
  },
  {
    title: 'Photo Tools',
    children: [
      {
        title: 'ImageConverter',
        href: '/image-converter/'
      },
      {
        title: 'ImageCompressor',
        href: '/image-compressor/'
      },
      {
        title: 'ImageResizer',
        href: '/image-resizer/'
      },
      {
        title: 'ImageCropper',
        href: '/image-cropper/'
      },
      {
        title: 'ImageFlipper',
        href: '/image-flipper/'
      },
      {
        title: 'ImageRotater',
        href: '/image-rotater/'
      },
      {
        title: 'ImageEditor',
        href: '/app/?tool=editor'
      },
    ]
  },
  {
    title: 'Popular Converter',
    children: [
      {
        title: 'JPG Conveter',
        href: '/image-converter/jpg/'
      },
      {
        title: 'PNG Conveter',
        href: '/image-converter/png/'
      },
      {
        title: 'AVIF Conveter',
        href: '/image-converter/avif/'
      },
      {
        title: 'WEBP Conveter',
        href: '/image-converter/webp/'
      },
      {
        title: 'SVG Conveter',
        href: '/image-converter/svg/'
      },
      {
        title: 'BMP Conveter',
        href: '/image-converter/bmp/'
      },
      {
        title: 'ICO Conveter',
        href: '/image-converter/ico/'
      },
    ]
  },
  {
    title: 'Resource',
    children: [
      {
        title: 'Plan & Pricing',
        href: '/pricing/'
      },
      {
        title: 'Support',
        href: '/support/'
      },
      {
        title: 'Contact Us',
        href: 'https://sharkfoto.com/company/contact-us/'
      },
      {
        title: 'Formats',
        href: '/format/'
      },
      {
        title: 'Privacy Policy',
        href: 'https://sharkfoto.com/company/trust/privacy/'
      },
      {
        title: 'Terms of Use',
        href: 'https://sharkfoto.com/company/trust/terms/'
      },
    ]
  },
  {
    title: 'Company',
    children: [
      {
        title: 'About Us',
        href: 'https://sharkfoto.com/company/'
      },
    ]
  }
]